import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl/dist';


const YearSelect = (props) => {
    const {
        msgId,
        initialYear,
        years,
        onChangeHandler
    } = props;

    const [ year, setYear ] = useState(initialYear);

    return (
        <fieldset className='year-select'>
            { msgId && <FormattedMessage id={msgId} tagName='label'/> }
            <select
                value={year}
                onChange={(e) => {
                    const selectedYear = parseInt(e.target.value);
                    setYear(selectedYear);
                    onChangeHandler(selectedYear);
                }}
            >
                {years.sort().reverse().map(year => (
                    <option
                        key={year}
                        value={year}
                    >
                        {year}
                    </option>
                ))}
            </select>
        </fieldset>
    );
};

export default YearSelect;